<curr-logo class="logo"></curr-logo>
<div class="static-page-title">PRIVACY POLICY OF CURRICULUM LTD</div>
<curr-privacy-policy-content></curr-privacy-policy-content>
